import { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import Phaser from 'phaser'
import { VisualGalleryScene } from '../game/scenes/VisualGalleryScene'
import { themeCss } from '../game/visual/theme'
import './DevVisualsPage.css'

/**
 * DEV-only production visual language gallery (M79–M82).
 * Not linked from player HOME.
 */
export function DevVisualsPage() {
  const hostRef = useRef<HTMLDivElement>(null)
  const gameRef = useRef<Phaser.Game | null>(null)

  useEffect(() => {
    const parent = hostRef.current
    if (!parent) return

    // Destroy any prior instance (React Strict Mode remount).
    if (gameRef.current) {
      gameRef.current.destroy(true)
      gameRef.current = null
    }
    parent.replaceChildren()

    const w = 390
    // Terrain + 6 tower LV rows + enemy grid (3 rows) + projectile
    const h = 1720
    const game = new Phaser.Game({
      type: Phaser.CANVAS,
      parent,
      backgroundColor: themeCss('background'),
      width: w,
      height: h,
      scene: [VisualGalleryScene],
      scale: {
        mode: Phaser.Scale.NONE,
        width: w,
        height: h
      },
      render: { antialias: true, pixelArt: false, transparent: false }
    })
    gameRef.current = game

    return () => {
      game.destroy(true)
      if (gameRef.current === game) gameRef.current = null
    }
  }, [])

  return (
    <main className="dev-visuals" data-testid="dev-visuals">
      <header className="dev-visuals__header">
        <p className="dev-visuals__eyebrow">DEV ONLY · M82</p>
        <h1 className="dev-visuals__title">Visual Language Gallery</h1>
        <p className="dev-visuals__sub">
          Hybrid geometric premium — shape identifies; color reinforces. Towers LV1→LV4 · 11
          enemy families.
        </p>
        <div className="dev-visuals__nav">
          <Link to="/">Home</Link>
          <Link to="/dev/labs">Map labs</Link>
        </div>
      </header>
      <div className="dev-visuals__canvas" ref={hostRef} data-testid="dev-visuals-canvas" />
      <section className="dev-visuals__notes">
        <h2>Checklist</h2>
        <ul>
          <li>Terrain/path sample (macro grass + continuous path)</li>
          <li>All 6 towers × LV1→LV4 (FIRE · FROST · CANNON · POISON · AA · MAGE)</li>
          <li>LV4 shows selected pad emphasis</li>
          <li>
            11 enemies + ELITE sample (NORMAL…AIR_BOSS; SHIELD shell; AIR shadow on FLYER /
            AIR_BOSS)
          </li>
          <li>FIRE projectile flare + Burn mark</li>
        </ul>
      </section>
    </main>
  )
}
